export default {
    noData: 'No Reviews',
};
